export const createTestIdToasterMessage = (msg: string, testId: string) => <span data-testid={testId}>{msg}</span>;
